import axios from 'axios'
import { IhLogUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

/**
 * 安全帽历史信息，分页查询
 */
export function getLogStatus(params) {
  const url = IhLogUrl + '/status/logStatus'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '安全帽历史信息', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 设备数据
 * 返回结果字段基本与设备列表一致，新增pattern设备模式
 * @param {*} params
 * let params = {
 *     ouId: 1, // 机构ID,非必填
 *     serialNumber: 'HWIH0500123', // 设备序列号,非必填
 *     specType: 1, // 设备类型,非必填
 *     userName: '用户名称', // 绑定用户名称,非必填
 *     onlineStatus: '1', // 在线状态 0-离线 1-在线,非必填
 *     simBinded: '0', // 绑定sim卡 0-否 1-是,非必填
 *     binded: '0', // 绑定用户 0-否 1-是,非必填
 *     startTime: '2023-09-01 12:00:00', // 流量统计开始时间（不传默认为当月一号）,非必填
 *     endTime: '2023-09-30 12:00:00', // 考流量统计结束时间（不传默认为当前时间）,非必填
 *     pattern: 1, // 设备模式,非必填
 *     pageNum: 1, // 页码
 *     pageSize: 20, // 每页条数
 * }
 */
export function getDeviceData(params) {
  const url = IhLogUrl + '/status/device'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('数据中心', '设备数据', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 导出设备数据
 * 返回结果字段基本与设备列表一致，新增pattern设备模式
 * @param {*} params
 * let params = {
 *     ouId: 1, // 机构ID,非必填
 *     serialNumber: 'HWIH0500123', // 设备序列号,非必填
 *     specType: 1, // 设备类型,非必填
 *     userName: '用户名称', // 绑定用户名称,非必填
 *     onlineStatus: '1', // 在线状态 0-离线 1-在线,非必填
 *     simBinded: '0', // 绑定sim卡 0-否 1-是,非必填
 *     binded: '0', // 绑定用户 0-否 1-是,非必填
 *     startTime: '2023-09-01 12:00:00', // 流量统计开始时间（不传默认为当月一号）,非必填
 *     endTime: '2023-09-30 12:00:00', // 考流量统计结束时间（不传默认为当前时间）,非必填
 *     pattern: 1, // 设备模式,非必填
 * }
 */
export function exportDeviceData(params) {
  const url = IhLogUrl + '/status/device/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
